import { Endpoints } from '../interfaces/endpoints.interface';

export const TIMECLOCK_ENDPOINTS: Pick<Endpoints, 'GET' | 'POST'> = {
   GET: (badge_uuid: string) => `/time-clocks/${badge_uuid}`,
   POST: (badge_uuid: string) => `/time-clocks/${badge_uuid}/time-registration`,
};
